<template>
    <div>
        <b-input-group class="flex-nowrap">
            <vue-multiselect
                ref="select"
                :class="stateClass"
                :internal-search="false"
                :loading="pending"
                :options="options"
                :placeholder="$t('Please select')"
                :show-labels="false"
                track-by="id"
                :value="value"
                autocomplete="off"
                @search-change="handleSearch"
                @input="$emit('input', $event)"
                @open="handleSearch(null)"
            >
                <div v-if="total" slot="beforeList" class="text-center position-sticky" style="top: 0">
                    {{ options.length }} / {{ total }}
                </div>

                <div slot="noOptions">
                    {{ $t('Type to search') }}
                </div>

                <div slot="noResult">
                    {{ $t('No results found') }}
                </div>

                <template slot="singleLabel" slot-scope="props">
                    <address-info :address="props.option" />
</template>

                <template slot="option" slot-scope="props">
                    <address-info :address="props.option" />
                </template>
            </vue-multiselect>
            <b-input-group-append v-if="!hideCreate">
                <b-button :title="$t('Create new address')" @click="showModal">
                    <fa icon="plus" :title="$t('Create new address')" />
                </b-button>
            </b-input-group-append>
        </b-input-group>

        <b-modal
            v-if="!hideCreate"
            ref="modal"
            :title="$t('Create new address')"
            hide-footer
            size="lg"
        >
                <b-form-group
                    class="px-1"
                    :label="$t('Internet search')"
                    label-for="search"
                >
                    <address-search
                        :placeholder="$t('Type to search')"
                        @input="fillFields"
                    />
                </b-form-group>

            <address-form
                ref="addressForm"
                class="m-n3"
                no-redirect
                @created="handleCreated"
            />
        </b-modal>
    </div>
</template>

<script>
    import AddressSearch from "@/components/selects/AddressSearch";
    import AddressForm from "@/components/addresses/AddressForm";
    import {formStateMixin} from 'bootstrap-vue/src/mixins/form-state';
    import VueMultiselect from 'vue-multiselect/src/Multiselect';
    import AddressInfo from "@/components/selects/AddressInfo";

    export default {
        name: 'AddressSelect',
        components: {AddressInfo, AddressForm, AddressSearch, VueMultiselect},
        mixins: [formStateMixin],
        props: {
            value: {
                type: Object,
                default: () => ({})
            },
            hideCreate: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                options: [],
                pending: false,
                total: null,
            };
        },
        computed: {
            apiUrl() {
                return '/api/addresses'
            }
        },
        mounted() {
            // this.$refs.select.$refs.search.autocomplete = 'off';
        },
        methods: {
            fillFields(address) {
                this.$refs.addressForm.fillFields(address);
            },

            handleSearch(search = null) {
                if (this.timeout) {
                    clearTimeout(this.timeout)
                    this.timeout = null;
                }

                this.timeout = setTimeout(() => this.search(search), 300);
            },

            search(search = null) {

                this.pending = true;

                this.axios.get(this.apiUrl, {
                    params: {search}
                }).then(({data}) => {
                    this.options = data.data || data;
                    this.total = data.total;

                }).catch(e => {
                    if (!e.response) {
                        throw e;
                    }
                }).finally(() => {
                    this.pending = false;
                })
            },

            handleCreated($event) {
                this.$emit('input', $event);
                this.$refs.modal.hide();
            },

            showModal() {
                this.$refs.modal.show();
            }
        }
    }
</script>
